import { Ean } from './ean';

export class Resume {
  id: number;
  totalPV: number;
  totalHT: number;
  totalTVA: number;
  percentTVA: number;
  ecotax: number;
  totalDiscountPV?: number;
  totalDiscountHT?: number;
  totalDiscountTVA?: number;
  hasPriceError?: boolean;
  priceErrorCode: string;

  products: Ean[];
}
